// Rejestracja atrybutów
wp.hooks.addFilter(
    "blocks.registerBlockType",
    "danone/search-attributes",
    function (settings, name) {
        if (name !== "core/search") {
            return settings;
        }

        return {
            ...settings,
            attributes: {
                ...settings.attributes,
                showLabel: {
                    type: "boolean",
                    default: true,
                },
                fontSize: {
                    type: "string",
                },
                textColor: {
                    type: "string",
                },
                style: {
                    type: "object",
                    default: {},
                },
            },
        };
    }
);

// Komponent edycji
const withSearchControls = wp.compose.createHigherOrderComponent(
    (BlockEdit) => {
        return (props) => {
            if (props.name !== "core/search") {
                return wp.element.createElement(BlockEdit, props);
            }

            const { attributes, setAttributes } = props;

            return wp.element.createElement(
                wp.element.Fragment,
                null,
                wp.element.createElement(BlockEdit, props),
                wp.element.createElement(
                    wp.blockEditor.InspectorControls,
                    null,
                    wp.element.createElement(
                        wp.components.PanelBody,
                        {
                            title: "Ustawienia etykiety",
                            initialOpen: true,
                        },
                        [
                            wp.element.createElement(
                                wp.components.ToggleControl,
                                {
                                    label: "Pokaż etykietę",
                                    checked: attributes.showLabel,
                                    onChange: (value) =>
                                        setAttributes({ showLabel: value }),
                                }
                            ),
                            attributes.showLabel &&
                                wp.element.createElement(
                                    "div",
                                    { style: { marginTop: "16px" } },
                                    [
                                        wp.element.createElement(
                                            wp.blockEditor.FontSizePicker,
                                            {
                                                value: attributes.fontSize,
                                                onChange: (value) =>
                                                    setAttributes({
                                                        fontSize: value,
                                                    }),
                                            }
                                        ),
                                        wp.element.createElement(
                                            "div",
                                            { style: { marginTop: "16px" } },
                                            wp.element.createElement(
                                                wp.components.BaseControl,
                                                { label: "Kolor tekstu" },
                                                wp.element.createElement(
                                                    wp.blockEditor.ColorPalette,
                                                    {
                                                        value: attributes.textColor,
                                                        onChange: (color) =>
                                                            setAttributes({
                                                                textColor:
                                                                    color,
                                                            }),
                                                    }
                                                )
                                            )
                                        ),
                                    ]
                                ),
                        ]
                    )
                )
            );
        };
    },
    "withSearchControls"
);

// Dodanie filtra
wp.hooks.addFilter(
    "editor.BlockEdit",
    "danone/with-search-controls",
    withSearchControls
);
